export function getRandomId(): string {
    const x = Math.random() * 1e8;
    const y = x < 0 ? Math.ceil(x) : Math.floor(x);

    return `f${y.toString(16)}`;
}
